import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, withDefaults } from 'vue'

interface IProps {
  value: number | string // 传递过来的值
  min?: number | string // 输入最小值
  max?: number | string // 输入最大值
  disabled?: boolean // 是否禁用
  size?: string // 输入框大小
  suffix?: string // 后缀文字
  width?: string // 宽度
  precision?: number // 保留位数
  inputId?: string // 输入框id
}


export default /*#__PURE__*/_defineComponent({
  __name: 'g-input-number-suffix',
  props: {
    value: { default: 0 },
    min: null,
    max: null,
    disabled: { type: Boolean, default: false },
    size: { default: 'default' },
    suffix: { default: 'mm' },
    width: { default: '100px' },
    precision: { default: 0 },
    inputId: null
  },
  emits: ['input', 'blur'],
  setup(__props: any, { emit: emits }) {

const props = __props as { value: number | string, min?: number | string, max?: number | string, disabled: boolean, size: string, suffix: string, width: string, precision: number, inputId?: string }




const defaultValue = ref(Number(props.value))

function handleInput($event: any) {
  // 只支持小数和数字
  const reg = /\d*\.{0,1}\d*$/
  if (reg.test($event.target.value)) {
    defaultValue.value = $event.target.value
  }
  $event.target.value = defaultValue.value
  if (props.max && Number(defaultValue.value) > Number(props.max)) {
    defaultValue.value = props.max as number
  }
  if (props.min && Number(defaultValue.value) < Number(props.min)) {
    defaultValue.value = props.min as number
  }
  emits('input', defaultValue.value)
}

function handleBlur() {
  // 处理如果传入了precision参数需要对数据进行保留小数的操作
  if (props.precision && props.precision > 0) {
    defaultValue.value = +Number(defaultValue.value).toFixed(2)
  }
}

watch(
  () => props.value,
  (val) => {
    defaultValue.value = val as number
    if (props.precision && props.precision > 0) {
      defaultValue.value = +Number(defaultValue.value).toFixed(2)
    }
  }
)

return { __sfc: true,emits, props, defaultValue, handleInput, handleBlur }
}

})